"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var QueueFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_QueueFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75a1.75 1.75 0 0 0 2.281 1.668 3.19 3.19 0 0 1 1.214-1.805 1.75 1.75 0 0 0-3.495.137ZM2.817 8H1.4A1.4 1.4 0 0 1 0 6.6c0-1.16 1.4-2.1 3.5-2.1.155 0 .307.005.454.015.097.95.612 1.778 1.358 2.295a5.966 5.966 0 0 0-1.886.734 4.267 4.267 0 0 0-.61.456ZM4.993 4.68a2.19 2.19 0 0 0 2.132 1.695h.009c.09-1.323.889-2.45 2.02-3.006a2.188 2.188 0 0 0-4.16 1.312ZM6.53 7.646c-.283.02-.555.055-.813.102a5.932 5.932 0 0 0-.94.252C3.51 8.46 2.75 9.295 2.75 10.25c0 .966.784 1.75 1.75 1.75h.627c.333-.463.778-.86 1.29-1.177.748-.464 1.673-.789 2.718-.952a3.634 3.634 0 0 1-1.87-2.245 8.778 8.778 0 0 0-.734.02ZM8.364 7.72a2.615 2.615 0 0 1-.187-1.614 2.627 2.627 0 0 1 5.199.519 2.625 2.625 0 0 1-5.012 1.094ZM10.833 10.75c3.104.025 5.168 1.425 5.168 3.15a2.1 2.1 0 0 1-2.1 2.1H7.6a2.1 2.1 0 0 1-2.1-2.1c0-.714.353-1.372.988-1.9.911-.76 2.403-1.25 4.261-1.25M10.833 10.75h-.083.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_QueueFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = QueueFill;
exports["default"] = _default;